import { IChatsAPIErrorResponse } from '@cian/chats-api/lib/browser-entry';

import { IAlertState } from './alert';
import { TChatActionModalState } from './chatActionModal';
import { TChatCustomActionModalState } from './chatCustomActionModal';
import { TChatListState } from './chatList';
import { EChatType } from './chatType';
import { TChatWindowState } from './chatWindow';
import { TChatbotState } from './chatbot';
import { TChatbotFiltersModalState } from './chatbotFiltersModal';
import { IContentFullscreenState } from './contentFullscreen';
import { TExperimentsState } from './experiments';
import { TFeedbackChatbotModalState } from './feedbackChatbotModal';
import { EHostType } from './hostType';
import { TLkType } from './lkType';
import { TMasterFiltersState } from './masterFilters';
import { TMobileLayoutActiveSideState } from './mobileSide';
import { IOffersSelector } from './offersForSelection';
import { TOpenedChats } from './openedChats';
import { EPageType } from './pageType';
import { TReplyTemplatesState } from './replyTemplates';
import { TSubAgentsState } from './subAgent';
import { IUserCardState } from './userCard';
import { TUser } from './userData';
import { TUsersStatusState } from './usersStatus';
import { TInternetStatus } from '../actions/internetStatus';
import { TDeleteMessageState } from '../slices/deleteMessageSlice';

export type TAPIErrors = IChatsAPIErrorResponse;

export enum ERequestApiStatus {
  Initial = 'initial',
  Pending = 'pending',
  Succeed = 'succeed',
  Failed = 'failed',
}

export enum EWsClientEventType {
  Message = 'message',
  Answer = 'answer',
  UnsubscribeUsersStatus = 'unsubscribeUsersStatus',
  SubscribeUsersStatus = 'subscribeUsersStatus',
}

export type TAppState = {
  alert: IAlertState;
  chatActionModal: TChatActionModalState;
  chatbot: TChatbotState;
  chatbotFiltersModal: TChatbotFiltersModalState;
  chatCustomActionModal: TChatCustomActionModalState;
  chatList: TChatListState;
  chatWindow: TChatWindowState;
  contentFullscreen: IContentFullscreenState;
  deleteMessage: TDeleteMessageState;
  experiments: TExperimentsState;
  feedbackChatbotModal: TFeedbackChatbotModalState;
  hostType: EHostType;
  chatType: EChatType | undefined;
  internetStatus: TInternetStatus;
  lkType: TLkType | null;
  masterFilters: TMasterFiltersState;
  mobileSide: TMobileLayoutActiveSideState;
  offersForSelection: IOffersSelector;
  openedChats: TOpenedChats;
  pageType: EPageType;
  listingType?: string;
  parentSource: string | undefined;
  parentOrigin: string | undefined;
  showErrorPage?: boolean;
  socketStatus: ERequestApiStatus;
  source: string | null;
  subAgents: TSubAgentsState;
  unreadMessagesCount: number;
  user: TUser;
  userCard: IUserCardState;
  usersStatus: TUsersStatusState;
  locationId: number;

  // Флаг раннего доступа
  isEarlyAccess?: boolean;
  replyTemplates: TReplyTemplatesState;

  /** Токен контекста cpc-аукциона, в дальнейшем может быть расширен на любой набор данных ликвидности */
  contextToken?: string;
};
